import React from 'react';
import PropTypes from 'prop-types';
import { getQuestion, getQuestionText } from './TQVMProbeDetails';
import { ICON, PROBE_DETAIL } from '../../../../constants/shared/CommonConstants';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const { DONE, CLOSE } = ICON;

const BDProbeDetails = ({ result, content }) => (
    <div className="bd">
        {result.responses.map(({ item_id: questionId, outcome }) => {
            const question = getQuestion(content.questions, questionId);
            const isResponseCorrect = outcome === PROBE_DETAIL.CORRECT_RESPONSE;

            return (
                <div key={generateReactKey(questionId)} className="assessment-row">
                    <div className="word">
                        <span className={isResponseCorrect ? '' : 'red'}>
                            {getQuestionText(question)}
                        </span>
                    </div>
                    {isResponseCorrect ? DONE : CLOSE}
                </div>
            );
        })}
    </div>
);

BDProbeDetails.propTypes = {
    result: PropTypes.object.isRequired,
    content: PropTypes.object.isRequired,
};

export default BDProbeDetails;
